export default {
  "en": {
    "milestone": {
      "actions": {
        "create": "Create milestone",
        "delete_milestones": "Delete milestone | Delete {count} milestones",
        "new": "Add new milestone"
      },
      "labels": {
        "bulk_assign_title": "Select units you want to assign milestone '{milestone_name}' to",
        "edit_units": "Edit units",
        "empty_state_subtitle": "Milestones make the building process more transparent for homebuyers",
        "empty_state_title": "Create a new milestone",
        "future_milestones": "Future milestones",
        "milestone": "Milestone",
        "milestone_name": "Milestone name",
        "milestone_unit_count": "0 units | 1 unit | {count} units",
        "new_milestone": "New milestone",
        "no_milestone": "No milestone assigned yet",
        "past_milestones": "Past milestones",
        "search_empty_state": "No milestones created yet. Click here to start",
        "units_without_milestone": "1 unit without milestone | {count} units without milestone",
        "warning_delete": "If you delete a milestone that has been assigned to a unit, the customer will lose sight of what milestone their unit is at. Be sure to assign a new milestone to these units!"
      },
      "toasts": {
        "bulk_assigned": "The milestone is successfuly assigned to the selected units",
        "create_success": "Milestone successfully created",
        "update_success": "Milestones have been successfully updated"
      },
      "validation": {
        "needName": "Name required"
      }
    }
  }
}